import { Box, Button, Dialog, IconButton, Typography } from '@mui/material';
import Close from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { PICKUP_MODAL } from '../../constants/strings';
import MapBox from '../MapBox';

const PickupModal = ({
  label,
  id,
  variant,
  disabled,
  selectedPickupPoint,
  initialPostcodeValue,
  onChange = noop,
  style,
  showSelectButton = true,
  dropOffFilterParam,
  pickup,
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (selectedPickupPoint) {
      setModalOpen(false);
    }
  }, [selectedPickupPoint]);

  return (
    <>
      <Dialog
        open={modalOpen}
        data-testid='pickup-modal'
        slotProps={{
          paper: {
            sx: {
              maxWidth: { xs: '100%', md: 500 },
              width: { md: 500 },
              height: { md: '70%', xs: '100%' },
            },
          },
          root: {
            'aria-labelledby': `${id}-title`,
            'aria-modal': 'true',
          },
        }}
        role='dialog'
        aria-labelledby={`${id}-title`}
        aria-modal='true'
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            bgcolor: 'background.paper',
            position: 'relative',
            borderRadius: 1,
            width: '100%',
            height: '100%',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexShrink: 0,
            }}
          >
            <Typography variant='h3' sx={{ p: 2 }} id={`${id}-title`}>
              {PICKUP_MODAL.TITLE}
            </Typography>
            <IconButton
              aria-label='close'
              sx={{ mr: 0.5 }}
              onClick={() => setModalOpen(false)}
            >
              <Close />
            </IconButton>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flex: 1,
              minHeight: 0,
              position: 'relative',
              transform: 'translateZ(0)',
            }}
          >
            <MapBox
              onChange={onChange}
              isModal={true}
              dropOffFilterParam={dropOffFilterParam}
              initialPostcodeValue={initialPostcodeValue}
              showSelectButton={showSelectButton}
              pickup={pickup}
            />
          </Box>
        </Box>
      </Dialog>
      <Box
        sx={{
          width: '100%',
          p: 1,
          display: 'flex',
          flexDirection: { md: 'row', xs: 'column' },
          gap: 2,
          alignItems: 'flex-start',
          justifyContent: 'space-between',
        }}
      >
        <Button
          id={id}
          variant={variant}
          disabled={disabled}
          fullWidth
          sx={style ? style : { mt: 2 }}
          onClick={() => setModalOpen(true)}
        >
          {label}
        </Button>
      </Box>
    </>
  );
};

PickupModal.propTypes = {
  addressData: PropTypes.shape({
    address: PropTypes.string,
    city: PropTypes.string,
    address2: PropTypes.string,
    postCode: PropTypes.string,
    longitude: PropTypes.number,
    latitude: PropTypes.number,
  }),
  onChange: PropTypes.func,
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  selectedPickupPoint: PropTypes.object,
  style: PropTypes.object,
  showSelectButton: PropTypes.bool,
  dropOffFilterParam: PropTypes.bool,
  pickup: PropTypes.bool,
};

export default PickupModal;
